import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import {
  PROFILE_SUBCARD_CONTENT_SX,
  PROFILE_SUBCARD_SX,
} from '../utils/profileFormConstants';

const EMPTY_INNER_SX = {
  py: 4,
  px: 2,
  textAlign: 'center',
  borderRadius: 1,
  bgcolor: (theme) =>
    theme.palette.mode === 'dark' ? 'action.selected' : 'grey.50',
  border: 1,
  borderColor: 'divider',
};

/**
 * Reusable profile-style block: title, optional description, optional top-right action,
 * then either an empty-state panel or `children` (e.g. table or fields).
 */
export default function ProfileSubsectionCard({
  title,
  description,
  headerAction = null,
  empty = false,
  emptyMessage = 'Nothing here yet',
  children,
  cardSx = {},
}) {
  return (
    <Card sx={{ ...PROFILE_SUBCARD_SX, ...cardSx }}>
      <CardContent sx={PROFILE_SUBCARD_CONTENT_SX}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'flex-start' },
            justifyContent: 'space-between',
            gap: 2,
            mb: 3,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle1"
              component="h2"
              fontWeight={600}
              sx={{ letterSpacing: '-0.01em' }}
            >
              {title}
            </Typography>
            {description ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5, maxWidth: 560, lineHeight: 1.5 }}
              >
                {description}
              </Typography>
            ) : null}
          </Box>
          {headerAction ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                flexShrink: 0,
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              {headerAction}
            </Box>
          ) : null}
        </Box>

        {empty ? (
          <Box sx={EMPTY_INNER_SX}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 400 }}>
              {emptyMessage}
            </Typography>
          </Box>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
